export default __webpack_public_path__ + "i18n/zh-CN.767eee3aeed18b9f53b2bb455252c6aa.json";